import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FCBACFB7-0431-4F59-BCEB-75D4325DC82C
 * name email-minus
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-minus.svg
 * tags
 */
export const EmailMinusIcon = createSvgIcon(<><path d="M13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M4 8V6L12 11L20 6V8L12 13L4 8M23 18V20H15V18H23Z" /></>, 'EmailMinusIcon');
export default EmailMinusIcon